import { render, staticRenderFns } from "./client-codes-tab.vue?vue&type=template&id=93fcce6c&scoped=true"
import script from "./client-codes-tab.vue?vue&type=script&lang=js"
export * from "./client-codes-tab.vue?vue&type=script&lang=js"
import style0 from "./client-codes-tab.vue?vue&type=style&index=0&id=93fcce6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93fcce6c",
  null
  
)

export default component.exports